import type { FeatureCollection, Geometry } from "geojson";
import type { APIError, ImportStatus } from ".";

export enum EmissionType {
	TRAFFIC = "TRAFFIC",
	POINT_SOURCE = "POINT_SOURCE",
	RESIDENTIAL = "RESIDENTIAL",
}

export interface Emission {
	id: number | string;
	name: string;
	type: EmissionType;
	geoserverFilter: number;
}

export type EmissionFeatureCollection = FeatureCollection<
	Geometry,
	{
		shape_id: number;
	}
>;
export interface PointSourceEmission {
	id: number | string;
	name: string;
	importStatus: ImportStatus;
	importErrors: APIError[];
	importWarnings: APIError[];
}

export interface Segment {
	segmentId: number;
	lineString_frontendSrid: string;
	roadType: string;
	roadTypeOld?: string;
	height_m: number;
	heightOld_m?: number;
	speed_km_h: number;
	speedOld_km_h?: number;
	vehicleCounts: Array<{
		vehicleType: string;
		count: number;
	}>;
	vehicleCountsOld?: Array<{
		vehicleType: string;
		count: number;
	}>;
	ifdmTimeFactor: string;
	ifdmTimeFactorOld?: string;
	barrierHeight_m: number;
	barrierHeightOld_m?: number;
}

export interface SegmentBulk {
	segmentId: number;
	lineString_frontendSrid: string;
	roadType: string;
	height_m: number | string;
	speed_km_h: number;
	vehicleCounts: Array<{
		vehicleType: string;
		count: number;
	}>;
}

export interface PointSource {
	// point_frontendSrid: string;
	id: number;
	name: string;
	height_m: number;
	diameter_m: number;
	temperature_K: number;
	flowrate_Nm3_s: number;
	nonox: number;
	ifdmTimeFactor: string;
	emissions_kg_h: Array<{
		substance: string;
		emission_kg_h: number;
	}>;
}

export interface Timefactor {
	id: number;
	serialNumber: number;
	nameKey: string;
	nameTranslation: string;
	type: "ROAD" | "POINTSOURCE";
}
